<template>
  <div class='h-dialogContainer'>
    <form id='BatchExportDialog'>
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.selectResource')}}:</div>
            <div class='h-borderBox h-filterTopoTree height-464'>
              <div class="h-topo-treebox">
                <div class="h-topo-tree">
                  <ejs-treeview ref='neTreeForBatchExport' id='neTreeForBatchExport' :fields='fieldsOfBatchExport' :nodeChecked='nodeCheckedOfBatchExport' :showCheckBox='true'></ejs-treeview>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.measureCycle')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist id='timeCycleOfBatch' :dataSource='dataSourceOfCycleBatch' :fields='fieldsOfCycleBatch' v-model="paramsOfBatchExport.meterTimePeriod" :placeholder='$t("Pm.chooseCycle")'></ejs-dropdownlist>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.timeRange')}}:</div>
            <ejs-radiobutton :label='$t("Pm.today")' name="time" value="0" :checked="true" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.yesterday")' name="time" value="1" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.currentWeek")' name="time" value="2" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.lastWeek")' name="time" value="3" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.specified")' name="time" value="4" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.start_time')}}:</div>
            <ejs-datetimepicker :change='validateOfBatchExportDialog' :locale='locale' name='startTimeOfBatchExport' :format='dateFormatOfBatch' :enabled='startTimeEnabledOfBatch' v-model='paramsOfBatchExport.meterBegTime'></ejs-datetimepicker>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.end_time')}}:</div>
            <ejs-datetimepicker :change='validateOfBatchExportDialog' :locale='locale' name='endTimeOfBatchExport' :max='maxDateOfBatchEndTime' :format='dateFormatOfBatch' :enabled='endTimeEnabledOfBatch' v-model='paramsOfBatchExport.meterEndTime'></ejs-datetimepicker>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import DateUtil from '../../Util/DateUtil';

export default {
  name: 'BatchExportDialog',
  props: [
    'timeCycles'
  ],
  components: {
  },
  data() {
    return {
      maxDateOfBatchEndTime: new Date(2100, 11, 31),
      fieldsOfBatchExport: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children'
      },
      dataSourceOfCycleBatch: [{}],
      locale: localStorage.getItem('locale'),
      fieldsOfCycleBatch: {
        value: 'value',
        text: 'text'
      },
      dateFormatOfBatch: 'yyyy-MM-dd HH:mm:ss',
      startTimeEnabledOfBatch: false,
      endTimeEnabledOfBatch: false,
      paramsOfBatchExport: {
        meterTimePeriod: 2,
        meterBegTime: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        meterEndTime: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`)
      },
      checkedNodesOfBatchExport: [],
      formObjOfBatchExportDialog: '',
      optionsOfBatchExportDialogValidation: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          startTimeOfBatchExport: {
            required: [true, `${this.$t('Pm.begTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.begTimeFormatError')}`]
          },
          endTimeOfBatchExport: {
            required: [true, `${this.$t('Pm.endTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.endTimeFormatError')}`]
          }
        }
      }
    };
  },
  methods: {
    rangeRadioChangeOfCycle(args) {
      switch (args.value) {
        case '0':
          this.setTodayBeginTime();
          this.setTodayEndTime();
          this.startTimeEnabledOfBatch = false;
          this.endTimeEnabledOfBatch = false;
          break;
        case '1':
          this.setYesterdayBeginTime();
          this.setYesterdayEndTime();
          this.startTimeEnabledOfBatch = false;
          this.endTimeEnabledOfBatch = false;
          break;
        case '2':
          this.setCurrentWeekBeginTime();
          this.setCurrentWeekEndTime();
          this.startTimeEnabledOfBatch = false;
          this.endTimeEnabledOfBatch = false;
          break;
        case '3':
          this.setLastWeekBeginTime();
          this.setLastWeekEndTime();
          this.startTimeEnabledOfBatch = false;
          this.endTimeEnabledOfBatch = false;
          break;
        case '4':
          this.paramsOfBatchExport.meterBegTime = '';
          this.paramsOfBatchExport.meterEndTime = '';
          this.startTimeEnabledOfBatch = true;
          this.endTimeEnabledOfBatch = true;
          break;
        default:
      }
    },
    setTodayBeginTime() {
      this.paramsOfBatchExport.meterBegTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
    },
    setTodayEndTime() {
      this.paramsOfBatchExport.meterEndTime = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
    },
    setYesterdayBeginTime() {
      this.paramsOfBatchExport.meterBegTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
    },
    setYesterdayEndTime() {
      this.paramsOfBatchExport.meterEndTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
    },
    setCurrentWeekBeginTime() {
      this.paramsOfBatchExport.meterBegTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
    },
    setCurrentWeekEndTime() {
      this.paramsOfBatchExport.meterEndTime = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
    },
    setLastWeekBeginTime() {
      this.paramsOfBatchExport.meterBegTime = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
    },
    setLastWeekEndTime() {
      this.paramsOfBatchExport.meterEndTime = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
    },
    getNeTreeOfBatchExport(neType, measureType) {
      this.$axios.post(`/lte/pm/getNeTree.html?systemId=1&neTypeId=${neType}&neVersionId=V16B.006&measureTypeCode=${measureType}`).then((response) => {
        this.fieldsOfBatchExport = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children'
        };
      });
    },
    nodeCheckedOfBatchExport() {

      let selectedNodes = [];

      const treeObj = document.getElementById('neTreeForBatchExport').ej2_instances[0];

      let dataList = this.$refs.neTreeForBatchExport.getTreeData()[0].children[0].children;

      for(let index = 0; index < dataList.length; index++){
        console.log(dataList[index]);
        if(treeObj.checkedNodes.indexOf(dataList[index].id) != -1){
          selectedNodes.push(dataList[index]);
        }
      }

      this.checkedNodesOfBatchExport = selectedNodes;
    },

    // 执行表单校验
    validateOfBatchExportDialog() {
      const formStatus = this.formObjOfBatchExportDialog.validate();
      if (!formStatus) {
        return false;
      }
      return true;
    },

    // 绑定表单校验
    bindValidateOfBatchDialog() {
      this.formObjOfBatchExportDialog = new FormValidator('#BatchExportDialog', this.optionsOfBatchExportDialogValidation);
    },
  },
  mounted() {
    this.setTodayBeginTime();
    this.setTodayEndTime();
    this.startTimeEnabledOfBatch = false;
    this.endTimeEnabledOfBatch = false;
    this.bindValidateOfBatchDialog();
  },
  watch: {
    timeCycles(timeCycles) {
      this.dataSourceOfCycleBatch = timeCycles;
    }
  }
};
</script>

<style>

</style>
